import { Localizable } from '@components/localizable/Localizable'
import { ComplementaryItem } from '@models/balance/ComplementaryItem'
import {
  SBAsyncSelect,
  SBAsyncSelectProps,
} from '@supplement-bacon/react-async-select'
import { initialQuery } from '@supplement-bacon/sb-table-filters'
import { SBRMFormActionProps, useSBRMForm } from '@supplement-bacon/sbrm-react'
import { Entity } from '@utils/Entities'
import MetadataKey from '@utils/MetadataKey'
import { requiredRule } from '@utils/rules'
import { Form, Input, InputNumber } from 'antd'
import { useCallback } from 'react'

const initialValues = {
  amount: 1,
}

type Props = SBRMFormActionProps & {
  error?: string
}

const Create = ({ form, formProps, error }: Props) => {
  const { metadata, getMetadata } = useSBRMForm()

  const membershipProfileId: () => number = useCallback(
    () => getMetadata(MetadataKey.MembershipProfileId),
    [getMetadata, metadata]
  )

  return (
    <Form
      {...formProps}
      form={form}
      layout="vertical"
      initialValues={initialValues}
    >
      <Form.Item
        name="profile"
        rules={[]}
        hidden
        style={{ display: 'none' }}
        initialValue={membershipProfileId()}
      >
        <Input type="hidden" />
      </Form.Item>

      <Localizable.Input
        name="name"
        rules={[requiredRule()]}
        label={'Name'}
        max={70}
      />

      <Form.Item
        name="currency"
        label={'Currency'}
        rules={[requiredRule()]}
        validateStatus={error && 'error'}
        help={error}
      >
        <SBAsyncSelect<ComplementaryItem>
          entity={Entity.currency}
          initialQuery={
            {
              ...initialQuery,
              filters: { membershipProfiles: [membershipProfileId()] },
            } as SBAsyncSelectProps<ComplementaryItem>['initialQuery']
          }
        />
      </Form.Item>

      <Form.Item name="amount" label={'Amount'} rules={[requiredRule()]}>
        <InputNumber mode="spinner" style={{ width: '100%' }} min={1} />
      </Form.Item>
    </Form>
  )
}

export default Create
